import { useEffect, useRef } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';

const TRUSTPILOT_CONFIG = {
    UK: {
        locale: 'en-US',
        businessUnitId: '5098036f00006400051e2962',
        reviewUrl: 'https://www.trustpilot.com/review/iwoca.co.uk'
    },
    DE: {
        locale: 'de-DE',
        businessUnitId: '54c8fb060000ff00057d0a8a',
        reviewUrl: 'https://www.trustpilot.com/review/www.iwoca.de'
    }
} as const;

export const TrustPilot = ({ theme }: { theme?: 'light' | 'dark' }) => {
    const ref = useRef(null);
    const config = TRUSTPILOT_CONFIG[getCountry()];

    useEffect(() => {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
        // When it is, it will automatically load the TrustBox.
        if ((window as any).Trustpilot) {
            (window as any).Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <div
            ref={ref}
            className="trustpilot-widget"
            data-locale={config.locale}
            data-template-id="5419b6ffb0d04a076446a9af"
            data-businessunit-id={config.businessUnitId}
            data-style-height="40px"
            data-style-width="100%"
            data-theme={theme ?? 'light'}
            data-testid="trustpilot-widget"
        >
            <a
                href={config.reviewUrl}
                target="_blank"
                rel="noopener noreferrer"
            >
                Trustpilot
            </a>
        </div>
    );
};
